import { BehaviorSubject, interval, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { HttpClient, HttpBackend, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GungVersionValidatorService {
  private http: HttpClient;
  private lastEtag: string | null = null;
  protected newVersionAvailableSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public newVersionAvailableObservable = this.newVersionAvailableSubject.asObservable();

  constructor(protected httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend);
  }

  public initVersionCheck() {
    interval(300000) // 300000 ms = 5 minutes
      .pipe(
        switchMap(() => {
          const url = `${window.location.origin}?cacheBuster=${new Date().getTime()}`;
          return this.http
            .get(url, {
              observe: 'response',
              responseType: 'text',
              headers: {
                maxAge: '-1'
              }
            })
            .pipe(
              catchError(error => {
                console.error('Error fetching version:', error);
                // Handle the error and return an empty response or a default value
                return of(new HttpResponse<string>({ body: '', headers: new HttpHeaders() }));
              })
            );
        }),
        tap((response: HttpResponse<string>) => {
          const etag = response.headers.get('Etag');

          // If there is no etag, we can't compare versions, usually because you are on localhost
          if (!etag) {
            return;
          }

          if (this.lastEtag !== null && this.lastEtag !== etag) {
            this.newVersionAvailableSubject.next(true);
          } else {
            this.lastEtag = etag;
          }
        })
      )
      .subscribe();
  }
}
